import React from "react";
import "./orderTracking.css";

const OrderTracking = ({ status, trackingData }) => {
    const isCanceled = status === "Canceled";
    
    const stages = isCanceled
        ? [
            { label: "Order Confirmed", key: "ORDER_CONFIRMED" },
            { label: "Canceled", key: "Canceled" }
          ]
        : [
            { label: "Order Confirmed", key: "ORDER_CONFIRMED" },
            { label: "Processing", key: "PROCESSING" },
            { label: "Shipped", key: "SHIPPED" },
            { label: "Delivered", key: "DELIVERED" }
          ];

    const getStageIndex = () => {
        switch (status) {
            case "ORDER_CONFIRMED": return 0;
            case "PROCESSING": return 1;
            case "SHIPPED": return 2;
            case "DELIVERED": return 3;
            case "Canceled": return 1;
            default: return 0;
        }
    };

    const currentStageIndex = getStageIndex();

    return (
        <div className={`tracking-container ${isCanceled ? "canceled" : ""}`}>
            <div className="progress-bar">
                {stages.map((stage, index) => (
                    <div key={index} className={`step ${index <= currentStageIndex ? (isCanceled ? "canceled" : "active") : ""}`}>
                        <div className="dot"></div>
                        <p>{stage.label}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OrderTracking;
